__turbopack_context__.v({
  "tooltip": "VDsh4q_tooltip",
  "tooltipText": "VDsh4q_tooltipText",
});
